document.addEventListener("turbo:frame-missing", (event) => {
  if (event.target.id === 'turbo_modal_content') {
    event.preventDefault()
    // improve, we already have the body of response in event. We not should fetch the response again.
    Turbo.visit(event.detail.response.url, { action: "advance" })
  }
})
